export const sideMenuBarWidth = '70%';
export const sideMenuBarMaxWidth = 250;
export const sideMenuBarMaxCollapsedWidth = 60;

export const displayContentPadding = 0;
export const contentMainPadding = 4;
export const menuContentPadding = 0;